import './i18n/config';

import StandaloneWrapper from './components/standalone-wrapper/StandaloneWrapper';
import FederatedApp from './FederatedApp';

function App() {
  return (
    <StandaloneWrapper>
      <FederatedApp />
    </StandaloneWrapper>
  );
}

export default App;
